import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import * as _ from 'lodash';
import { SelectItem, MessageService } from 'primeng/api';
import { ManageFolderComponent } from './components/manage-folder/manage-folder.component';
import { ManageDocComponent } from './components/manage-doc/manage-doc.component';
import { LanguageSelectionComponent } from './components/language-selection/language-selection.component';
import { BasicDetailsEditComponent } from './components/basic-details-edit/basic-details-edit.component';
import { ContactsEditComponent } from './components/contacts-edit/contacts-edit.component';
import { EditEngagementMemoryServiceService } from './edit-engagement-memory-service/edit-engagement-memory-service.service';
import { LanguageService } from '../../framework/services/language.service';
import { EngagementManagementService } from '../../framework/services/engagement-mgmt.service'
import { LabelcardMgmtService } from 'src/framework/services/labelcard-mgmt.service';
import { HomeService } from 'src/framework/services/home.service';
import { JurisdictionService } from 'src/framework/services/jurisdiction.service';
import { CommonService } from 'src/framework/services/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { TopicCardComponent } from './components/topic-card/topic-card.component';
import { CategoryConstant } from '../shared/app-constants/category-constants';


@Component({
  selector: 'app-edit-engagement',
  templateUrl: './edit-engagement.component.html',
  styleUrls: ['./edit-engagement.component.css']
})
export class EditEngagementComponent implements OnInit {

  languageList: SelectItem[];
  selectedEngagement: any;
  languages: string[];
  languageControl = new FormControl();
  currentStep = 0;
  alreadySelectedLanguageId = 0;
  index = 2;
  folderName: any;
  engagementSteps: { [key: string]: number } = {
    basicDetailsStep: 0,
    contactsStep: 1,
    folderStep: 2,
    authorizationStep: 3
  };

  showEngagementSection: ShowEngagementSection;
  languageForm: FormGroup;
  languageCtrl: FormControl;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('languageSelectionComponent') languageSelectionComponent: LanguageSelectionComponent;
  @ViewChild('basicDetailsEditComponent') basicDetailsEditComponent: BasicDetailsEditComponent;
  @ViewChild('contactsEditComponent') contactsEditComponent: ContactsEditComponent;
  @ViewChild('manageFolderComponent') manageFolderComponent: ManageFolderComponent;
  @ViewChild('manageDocComponent') manageDocComponent: ManageDocComponent;
  @ViewChild('topicCardComponent') topicCardComponent: TopicCardComponent;
  selectedLanguages: any[] = [];
  isLanguageError = false;
  engLanguage: any[] = [];
  appLanguageList: any[] = [];
  engagementDetail = {
    appLanguage: 1,
    engagementId: 1,
    engagementRole: '',
    engagementName: '',
    engStatusId: 1,
    engStatusName: '',
    engInitialDate: null,
    engLanguage: [{
      "languageId": 1,
      "languageName": "English",
      "languageFlagPath": "../../assets/flags/English.png"
    }],
    engLanguageFrench: [{
      "languageId": 1,
      "languageName": "Anglaise",
      "languageFlagPath": "../../assets/flags/English.png"
    }]
  };
  userDetail: any = {};
  loadChild: boolean = false;
  selectedLanguageId: number;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;
  selectedTab = "Document";
  versionId = 0;
  selectedLangStatusJson: any;
  defaultEngStatusJson: any;
  selectedLangLabelJson: any;
  defaultEngLangLabelJson: any;


  constructor(private engagementMemoryService: EditEngagementMemoryServiceService,
    private languageSerivce: LanguageService,
    private engagementManagementService: EngagementManagementService,
    private labelCardService: LabelcardMgmtService,
    private service: HomeService,
    private jurisdictionService: JurisdictionService,
    private commonService: CommonService,
    private spinner: NgxSpinnerService,
    private confirmationService: ConfirmationService,
    private languageService: LanguageService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService) {

    this.engagementMemoryService.resetEngagementMemory();
    this.showEngagementSection = new ShowEngagementSection(false, false, false, false, false);
    this.getAllLanguages();
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.route.queryParams.subscribe(params => {
      this.selectedTab = params['type'];
      this.versionId = params['DocId']
      if (this.selectedTab == 'TopicCard') {
        this.index = 3;
      } else if (this.selectedTab == 'EngagementDetails') {
        this.index = 0;
      }
    });
    this.loadLanguageLabel();
    this.loadChild = false;
    this.selectedEngagement = [];
    if (localStorage.getItem('userModel')) {
      this.userDetail = JSON.parse(localStorage.getItem('userModel'))
      sessionStorage.setItem('userDetail', JSON.stringify(this.userDetail));
    }
    this.preLoadData()
      .then(res => this.initializeEngagementData()
        .then(res => {
          sessionStorage.setItem('engagementDetail', JSON.stringify(this.engagementDetail));
          this.loadChild = true;

          if (sessionStorage.getItem('engagementData')) {
            this.selectedEngagement = JSON.parse(sessionStorage.getItem('engagementData'));
          }
          this.engagementMemoryService.setEngagementId(this.engagementDetail.engagementId);
        }));

  }

  public preLoadData() {
    return new Promise((resolve, reject) => {
      this.labelCardService.getLanguageList().subscribe(res => {
        if (res) {
          //success
          res.forEach(element => {
            if (element.isAppLanguage) {
              this.appLanguageList.push({
                languageId: element.languageId,
                languageName: element.name,
                languageFlagPath: element.languagePath,
                languageCode:element.languageCode
              });
            }

          });

          if (this.appLanguageList.length > 0) {
            sessionStorage.setItem('appLanguageList', JSON.stringify(this.appLanguageList));
          }
        } else {
          //display error
        }
        resolve(1);

      });
    });

  }

  getArchievedFiles() {
    this.spinner.show();
    this.service.getEngagementDocsById(this.selectedEngagement.engagementId).subscribe((data) =>{
      this.downloadFiles(data,0);
     });
  }
  async downloadFiles(totalDocs,docIds)  
  {
    var documentCount=0;
    var strdocids ='';
    await this.service.getEngagementDetailsById(this.selectedEngagement.engagementId, docIds).subscribe((res) => {
      //res.responseModel.data.folderPath = res.responseModel.data.FolderPath;
      //res.responseModel.data.folderName = res.responseModel.data.FolderName;
        if(res.responseModel != undefined &&(res.responseModel.data.FolderPath ! = null || res.responseModel.data.FolderPath != undefined))
        {
          strdocids = res.count.toString();
          documentCount = res.count.length;
          this.folderName = res.responseModel.data.FolderName;
          this.service.getEngagementZipFolder(this.folderName).subscribe((resp) => {
            const blob = new Blob([resp], { type: resp.type });
            this.spinner.hide();
            const element = document.createElement('a');
            element.href = URL.createObjectURL(blob);
            element.download = this.selectedEngagement.name.replaceAll("."," ");;
            document.body.appendChild(element);
            element.click();
            if(documentCount !=0 && documentCount<totalDocs){
              this.downloadFiles(totalDocs,strdocids)}
          });
        }else{this.spinner.hide();}
      
      });
      
  }
  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishStatusMappings, selectedLangStatusMappings: any;
    let englishLangLabelMappings, selectedLangLabelMappings: any;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        if (this.alreadySelectedLanguageId != 0) {
          if (this.alreadySelectedLanguageId != data.Id && this.router.url == "/edit-engmt") {

            this.router.navigate(["/home"], { queryParams: { engagementType: 'active' } })
          }
        }
        this.selectedLanguageId = data.Id
        this.alreadySelectedLanguageId = data.Id;
        this.getJurisdiction(this.selectedLanguageId);
        this.getEngagementRoles(this.selectedLanguageId);

      });

      this.languageSerivce.currentData.subscribe(data => {


        this.selectedLanguageId = data.Id

      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;

        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishStatusMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLangLabelMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangStatusMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.EditEngagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangStatusMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangStatusMappings = englishStatusMappings;
              selectedLangLabelMappings = englishLangLabelMappings;

            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangLabelJson = JSON.parse(selectedLangLabelMappings?.languageMappingJSON ?? englishLangLabelMappings.languageMappingJSON);
          this.defaultEngLangLabelJson = JSON.parse(englishLangLabelMappings.languageMappingJSON);

          this.selectedLangStatusJson = JSON.parse(selectedLangStatusMappings?.languageMappingJSON ?? englishStatusMappings.languageMappingJSON);
          this.defaultEngStatusJson = JSON.parse(englishStatusMappings.languageMappingJSON);
          this.islabelLoaded = true;
          resolve(1);
        }
        else {

        }
      });
    })
      .catch(err => {


        console.log(err);
      });
  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  languageReplacer(labelKey): string {
    return this.selectedLangLabelJson[labelKey]?.trim() ? this.selectedLangLabelJson[labelKey] ?? 'text not found' : this.defaultEngLangLabelJson[labelKey] ?? 'text not found';
  }


  statusReplacer(labelKey): string {
    return this.selectedLangStatusJson[labelKey]?.trim() ? this.selectedLangStatusJson[labelKey] ?? 'text not found' : this.defaultEngStatusJson[labelKey] ?? 'text not found';
  }

  initializeEngagementData() {
    let languageMappingIds: any[] = [];
    let searchObj;
    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.engagementDetail.appLanguage = JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }
      if (sessionStorage.getItem('engagementData')) {
        let sessionEngObj = JSON.parse(sessionStorage.getItem('engagementData'));
        this.engagementDetail.engagementId = sessionEngObj['engagementId'];
        this.engagementDetail.engagementName = sessionEngObj['name'];
        this.engagementDetail.engStatusId = sessionEngObj['statusId'];
        this.engagementDetail.engStatusName = sessionEngObj['statusName'];
        this.engagementDetail.engagementRole = sessionEngObj['engagementRoleName'];
        this.engagementDetail.engInitialDate = new Date(sessionEngObj['initialdatestringformat']);

        if (sessionEngObj['languageMappings'] !== null) {
          this.engagementDetail.engLanguage = [];
          languageMappingIds = sessionEngObj['languageMappings']?.toString().split(',');
          if (languageMappingIds.length > 0) {
            languageMappingIds?.sort((a, b) => a.localeCompare(b));
            languageMappingIds.forEach(langId => {
              searchObj = this.appLanguageList?.filter(x => Number(x.languageId) === Number(langId))[0];
              if (searchObj) {
                this.engagementDetail.engLanguage.push({
                  languageId: searchObj.languageId,
                  languageName: searchObj.languageName,
                  languageFlagPath: searchObj.languageFlagPath
                })
              }
            });
          }
        }

      }
      resolve(1);
    });
  }

  getStatusPillClass(statusId) {

    let pillClass = '';
    if (statusId) {
      if (statusId === 2 || statusId === 4 || statusId === 7)
        pillClass = 'pill pill--approved m-0';
      else if (statusId === 1)
        pillClass = 'pill pill--closed m-0';
      else if (statusId === 3 || statusId === 6)
        pillClass = 'pill pill--failed m-0';
      // else if (statusId === 'authorized')
      //   pillClass = 'pill pill--hold m-0';
    }

    return pillClass;
  }

  tabViewChange(event) {
    this.index = event.index;
    let index = event.index;
    if (index === 1) {
      this.manageFolderComponent.getFolderStructure();
    }
    else if (index === 2) {
      this.manageDocComponent.getFolderStructure();
    }
    else if (index === 3) {
      this.topicCardComponent.getTopicCards()
    }
  }

  getAllLanguages() {
    this.spinner.show();
    this.languageSerivce.getAllLanguages().subscribe((response) => {
      if (response.responseStatus == 1) {

      } else {
        if (response != null && response.length > 0) {
          this.engagementMemoryService.setLanguages(response.filter(t => t.isAppLanguage));
          this.getJurisdiction(this.selectedLanguageId);
        }
      }
    })
  }

  getJurisdiction(languageId: number) {
    this.jurisdictionService.getJurisdictionDropDown(languageId).subscribe((response) => {
      if (response.responseStatus == 1) {
      } else {
        if (response != null && response.data.length > 0) {
          this.engagementMemoryService.setJurisdictionOption(response.data);
          this.getEngagementRoles(this.selectedLanguageId);
        }
      }
    })
  }

  getEngagementRoles(languageId: number) {
    this.commonService.getEngagementRoles(languageId).subscribe((response) => {
      if (response.responseStatus == 1) {

      } else {
        if (response != null && response.data.length > 0) {
          this.engagementMemoryService.setEngagementRoles(response.data);
          this.getSelectedLanguages();
        }
      }
    })
  }

  getSelectedLanguages() {
    if (sessionStorage.getItem('engagementData')) {
      let sessionEngObj = JSON.parse(sessionStorage.getItem('engagementData'));
      let engagementId = sessionEngObj['engagementId'];
      this.languageSerivce.getEngagementSelectedLanguages(engagementId).subscribe((response) => {
        if (response.data && response.data.length > 0) {
          this.engagementMemoryService.setSelectedLanguages(response.data.filter(t => t.isAppLanguage));
        }
        this.showEngagementSection = new ShowEngagementSection(false, true, false, false, false);
        this.spinner.hide();
      })
    }
  }

  showNextControl(event) {
    this.stepper.next();
  }

  showPreviousControl(event) {
    this.stepper.previous();
  }

  selectionChange(event: any) {
    if (event.selectedIndex == 0)
      this.showEngagementSection = new ShowEngagementSection(false, true, false, false, false);
    else if (event.selectedIndex == 1)
      this.showEngagementSection = new ShowEngagementSection(false, false, true, false, false);
    else if (event.selectedIndex == 2)
      this.showEngagementSection = new ShowEngagementSection(false, false, false, true, false);
    else if (event.selectedIndex == 3)
      this.showEngagementSection = new ShowEngagementSection(false, false, false, false, true);
  }

  deleteEngagement() {
    this.confirmationService.confirm({
      message: this.labelReplacer('Areyousurethatyouwanttodeletethisengagement?'),
      accept: () => {
        this.spinner.show();
        const engagementId = this.selectedEngagement?.engagementId;
        if (!engagementId) {
          this.spinner.hide();
          this.messageService.add({
            summary: this.labelReplacer('Erroroccuredwhiledeletingengagement'),
            detail: 'Unable to identify the engagement to delete.',
            sticky: false,
            severity: 'error'
          });
          return;
        }

        this.engagementManagementService.deleteEngagement(engagementId).subscribe((response) => {
          if (response?.responseStatus !== 0) {
            this.messageService.add({
              summary: this.labelReplacer('Erroroccuredwhiledeletingengagement'),
              detail: response?.message || 'Unable to delete the engagement.',
              sticky: false,
              severity: 'error'
            });
            this.spinner.hide();
            return;
          }

          this.messageService.add({
            summary: this.labelReplacer('Engagementdeletedsuccessfully'),
            detail: 'Sucess',
            sticky: false,
            severity: 'success'
          });
          setTimeout(() => {
            this.spinner.hide();
            this.router.navigate(['/home'], { queryParams: { engagementType: 'active' } });
          }, 3000);
        }, (error) => {
          this.messageService.add({
            summary: this.labelReplacer('Erroroccuredwhiledeletingengagement'),
            detail: error?.error?.message || 'Unable to delete the engagement.',
            sticky: false,
            severity: 'error'
          });
          this.spinner.hide();
        });
      }
    });
  }



  navigateToDetail() {
    this.router.navigate(['/detail-engmt'], { queryParams: { 'eid': this.engagementDetail.engagementId } });
  }
}

export class ShowEngagementSection {
  showLanguageSelection: boolean;
  showEngagementDetails: boolean;
  showContact: boolean;
  showAuthorization: boolean;
  showFolderManagement: boolean
  constructor(showLanguageSelection, showEngagementDetails, showContact, showFolderManagement, showAuthorization) {
    this.showLanguageSelection = showLanguageSelection;
    this.showEngagementDetails = showEngagementDetails;
    this.showContact = showContact;
    this.showAuthorization = showAuthorization;
    this.showFolderManagement = showFolderManagement;
  }
}
